import React from 'react';
import { Route, RouteProps, Redirect, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface SuperUserRouteProps extends RouteProps {
    component: React.ComponentType<any>;
}

const SuperUserRoute: React.FC<SuperUserRouteProps> = ({ component: Component, ...rest }) => {
    const { isAuthenticated, user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center min-vh-100">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Carregando...</span>
                </div>
            </div>
        );
    }

    // Check if user is authenticated and is a super user
    const isSuperUser = isAuthenticated && user?.su === true;

    return (
        <Route
            {...rest}
            render={props =>
                isSuperUser ? (
                    <Component {...props} />
                ) : (
                    <Redirect
                        to={{
                            pathname: "/home",
                            state: { from: location }
                        }}
                    />
                )
            }
        />
    );
};

export default SuperUserRoute; 